import { render, staticRenderFns } from "./IconTh.vue?vue&type=template&id=11219440&scoped=true&"
import script from "./IconTh.vue?vue&type=script&lang=js&"
export * from "./IconTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11219440",
  null
  
)

export default component.exports